import { useCallback } from 'react';

import { usePromoCodeGroupDeleteMutation } from '@occc/graphql';
import { useMutation } from '@occc-app/dataAccessLayer/utils';

export const useDeletePromoCodeGroup = () => {
  const [mutate, { loading }] = useMutation(usePromoCodeGroupDeleteMutation);

  const deletePromoCodeGroup = useCallback(
    (params: { id: string }) =>
      mutate({
        variables: {
          id: params.id,
        },
      }),
    [mutate],
  );

  return { delete: deletePromoCodeGroup, isLoading: loading };
};
